/** Network pulse: is the relay alive and is the firehose moving? Read from the relay's public
 *  /metrics (per retention class). Independent of the viewer's cells: "the network is fine,
 *  it just has nothing new for you" is exactly the distinction the Now tab wants to make. */
export interface RelayPulse { headSeq: number; newestMs: number }

export async function fetchRelayPulse(baseUrl: string, fetchImpl: typeof fetch = fetch): Promise<RelayPulse | null> {
  try {
    const res = await fetchImpl(`${baseUrl}/metrics`);
    if (!res.ok) return null;
    const body = (await res.json()) as { classes?: Array<{ class?: string; headSeq?: number; newestMicros?: number }> };
    const eph = body.classes?.find((c) => c.class === "ephemeral");
    if (!eph || typeof eph.headSeq !== "number" || typeof eph.newestMicros !== "number") return null;
    return { headSeq: eph.headSeq, newestMs: Math.floor(eph.newestMicros / 1000) };
  } catch {
    return null;
  }
}

export type PulseState = { kind: "live"; ageS: number } | { kind: "quiet"; ageS: number } | { kind: "unreachable" };

/** live: newest event under 2 min old; quiet: older; unreachable: no answer. */
export function pulseState(p: RelayPulse | null, nowMs: number): PulseState {
  if (!p) return { kind: "unreachable" };
  const ageS = Math.max(0, Math.round((nowMs - p.newestMs) / 1000));
  return ageS < 120 ? { kind: "live", ageS } : { kind: "quiet", ageS };
}
